"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterPriceAction;
(function (SfilterPriceAction) {
    SfilterPriceAction.ON_PRICE_SECTION_TOGGLE = 'ON_PRICE_SECTION_TOGGLE';
    SfilterPriceAction.SET_PRICE_SECTION = 'SET_PRICE_SECTION';
    SfilterPriceAction.ON_SELECT_PRICE_RANGE = 'ON_SELECT_PRICE_RANGE';
    SfilterPriceAction.SET_PRICE_RANGE_SELECTED = 'SET_PRICE_RANGE_SELECTED';
    SfilterPriceAction.SET_PRICE_RANGE_CUSTOM = 'SET_PRICE_RANGE_CUSTOM';
    SfilterPriceAction.ON_PRICE_CUSTOM_CHANGED = 'ON_PRICE_CUSTOM_CHANGED';
    SfilterPriceAction.SET_CUSTOM_PRICE_VISIBLE = 'SET_CUSTOM_PRICE_VISIBLE';
    SfilterPriceAction.ON_TOGGLE_CUSTOM_PRICE_VISIBLE = 'ON_TOGGLE_CUSTOM_PRICE_VISIBLE';
    SfilterPriceAction.SET_MODE = 'SET_MODE';
    SfilterPriceAction.SET_PRICE_SECTION_CURRENCY = 'SET_PRICE_SECTION_CURRENCY';
    SfilterPriceAction.setMode = typesafe_actions_1.createAction(SfilterPriceAction.SET_MODE, function (resolve) { return function (mode) { return resolve(mode); }; });
    SfilterPriceAction.togglePriceSection = typesafe_actions_1.createAction(SfilterPriceAction.ON_PRICE_SECTION_TOGGLE, function (resolve) { return function () { return resolve(); }; });
    SfilterPriceAction.setPriceSection = typesafe_actions_1.createAction(SfilterPriceAction.SET_PRICE_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterPriceAction.onSelectPriceRange = typesafe_actions_1.createAction(SfilterPriceAction.ON_SELECT_PRICE_RANGE, function (resolve) {
        return function (currentIndex, from, to) { return resolve({ currentIndex: currentIndex, from: from, to: to }); };
    });
    SfilterPriceAction.setPriceRangeSelected = typesafe_actions_1.createAction(SfilterPriceAction.SET_PRICE_RANGE_SELECTED, function (resolve) {
        return function (from, to) { return resolve({ from: from, to: to }); };
    });
    SfilterPriceAction.setPriceRangeCustom = typesafe_actions_1.createAction(SfilterPriceAction.SET_PRICE_RANGE_CUSTOM, function (resolve) {
        return function (from, to) { return resolve({ from: from, to: to }); };
    });
    SfilterPriceAction.onPriceCustomChanged = typesafe_actions_1.createAction(SfilterPriceAction.ON_PRICE_CUSTOM_CHANGED, function (resolve) {
        return function (from, to, fromIndex, toIndex) {
            return resolve({ from: from, to: to, fromIndex: fromIndex, toIndex: toIndex });
        };
    });
    SfilterPriceAction.setCustomPriceVisible = typesafe_actions_1.createAction(SfilterPriceAction.SET_CUSTOM_PRICE_VISIBLE, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterPriceAction.onToggleCustomPriceVisible = typesafe_actions_1.createAction(SfilterPriceAction.ON_TOGGLE_CUSTOM_PRICE_VISIBLE, function (resolve) { return function () { return resolve(); }; });
    SfilterPriceAction.setCurrency = typesafe_actions_1.createAction(SfilterPriceAction.SET_PRICE_SECTION_CURRENCY, function (resolve) {
        return function (currencyId) { return resolve(currencyId); };
    });
})(SfilterPriceAction || (SfilterPriceAction = {}));
exports.default = SfilterPriceAction;
